module.exports = __webpack_public_path__ + "img/pic_210006_2.f63bdaa9.jpg";